export const getUrlParams = function (paramName) {
  var url = new URL(window.location.href);

  return url.searchParams.getAll(paramName);
}

